import ModalSlideHeader from './modal_slide_header';

export default ModalSlideHeader;
